import { createSelector } from "reselect";

const selectQuestions = (state) => state.questions;

export const selectIsFetchingQuestions = createSelector(
  [selectQuestions],
  (questions) => questions.isFetchingQuestions
);

export const selectIsFetchingQuestion = createSelector(
  [selectQuestions],
  (questions) => questions.isFetchQuestion
);

export const selectIsCreatingAddingKnowledge = createSelector(
  [selectQuestions],
  (questions) => questions.isAddingKnowledge
);
export const selectQuestion = createSelector(
  [selectQuestions],
  (questions) => questions.question
);

export const selectQuestionsList = createSelector(
  [selectQuestions],
  (questions) => questions.questions
);

export const selectIsEditingQuestion = createSelector(
  [selectQuestions],
  (questions) => questions.isEditingQuestion
);

export const selectIsDeletingQuestion = createSelector(
  [selectQuestions],
  (questions) => questions.isDeletingQuestion
);

export const selectIsGenerateSolution = createSelector(
  [selectQuestions],
  (questions) => questions.isGeneratingSolution
);

export const selectGenerateSolution = createSelector(
  [selectQuestions],
  (questions) => questions.generatedSolution
);

export const selectIsMarkingAnswer = createSelector(
  [selectQuestions],
  (questions) => questions.isMarkingQuestion
);

export const selectMarkedAnswer = createSelector(
  [selectQuestions],
  (questions) => questions.markedAnswer
);

export const selectAIQuestions = createSelector(
  [selectQuestions],
  (questions) => questions.aiQuestions
);

export const selectIsFetchingSchools = createSelector(
  [selectQuestions],
  (questions) => questions.isFetchingSchools
);

export const selectSchools = createSelector(
  [selectQuestions],
  (questions) => questions.schools
);